import styled, { css } from 'styled-components';
import { breakpoint, sizes } from 'variables';
import { SvgSprite } from 'modules/svgSprite';

const CardIcon = css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 85px;
    height: 85px;
    z-index: 1;

    ${breakpoint.up(sizes.md)} {
        width: 90px;
        height: 90px;
    }

    ${breakpoint.up(sizes.xl)} {
        width: 95px;
        height: 95px;
    }
`;

export const CardLogo = styled(SvgSprite)`
    ${CardIcon}
`;

export const AnimatedCardLogo = styled.div`
    ${CardIcon};

    background-image: url(/images/matas-live-card-animated.svg);
`;

export const AnimatedPlayLogo = styled.div`
    ${CardIcon};

    background-image: url(/images/matas-live-play-animated.svg);
`;

export const AnimatedUpcomingLogo = styled.div`
    ${CardIcon};

    background-image: url(/images/matas-live-upcoming-animated.svg);
`;
